var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.store.getters.isEnterprise)?_c(_setup.EnterpriseNeed):_vm._e(),(_setup.store.getters.isEcosystem)?_c(_setup.EcosystemNeed):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }